import styled from '@emotion/styled';

export const Wrapper = styled.div<{ notFirstMobileStep: boolean }>`
  display: grid;
  height: 100vh;
  grid-template-columns: 1fr 1fr;
  ${({ theme, notFirstMobileStep }) => theme.media.showAt({ to: 2 })`
    grid-template-columns: 1fr;
    & > div:first-of-type {
      order: 2;
      align-items: ${notFirstMobileStep ? 'flex-start' : 'center'};
      padding-top: ${notFirstMobileStep ? theme.spacing(5) : 0};
    }
  `}
`;

export const BGSide = styled.div<{ bg: string; }>`
  overflow: hidden;
  margin: ${({ theme }) => theme.spacing(2)};
  border-radius: 32px;
  border: 1px solid ${({ theme }) => theme.colors.neutrals.grey8};
  background-image: url("${({ bg }) => bg}");
  background-size: cover;
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    margin: ${theme.spacing(1)};
  `}
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const ContentWrapper = styled.div`
  margin: 0 auto;
  width: 400px;
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    width: 100%;
    padding: 0 ${theme.spacing(3)};
  `}
`;

export const LoginContentWrapper = styled.div`
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    margin: 0 auto;
    max-width: 330px;
  `}
`;

export const Back = styled.div`
  position: absolute;
  right: 24px;
  top: 24px;
  cursor: pointer;
`;
